<template>
<div style="height: 100%;margin: 0 20px">
  <div style="height: 10px"></div>
  <div style="height: calc(100% - 20px);">
    <div style="height: 55%;width: 100%">
      <el-row style="height: 100%">
        <el-col :span="6" style="height: 100%">
          <div style="width: 100%;height: 100%">
            <person-statistic ref="personStatistic"></person-statistic>
          </div>
        </el-col>
        <el-col :span="18" style="height: 100%">
          <div style="width: calc(100% - 20px);height: 100%;margin-left: 20px">
            <iot-situation ref="iotSituation"></iot-situation>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: calc(45% - 20px);width: 100%;padding: 10px 0">
      <el-row style="height: 100%">
        <el-col :span="6" style="height: 100%">
          <div style="width: 100%;height: 100%">
            <health-data ref="healthData"></health-data>
          </div>
        </el-col>
        <el-col :span="18" style="height: 100%">
          <div style="width: calc(100% - 20px);height: 100%;margin-left: 20px">
            <checkin-statistic ref="checkinStatistic"></checkin-statistic>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  <div style="height: 10px"></div>
</div>
</template>

<script>
import personStatistic from './dataScreenComponents/personStatistic'
import healthData from './dataScreenComponents/healthData'
import iotSituation from './dataScreenComponents/iotSituation'
import checkinStatistic from './dataScreenComponents/checkinStatistic'
import {queryelderlydataview} from '../../api/yanglaoyuan/dataScreen'
export default {
  name: 'dataScreen',
  components: {checkinStatistic, iotSituation, healthData, personStatistic},
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      queryelderlydataview().then(res => {
        let data = res.data.dataviewcount
        this.$refs.personStatistic.getStartData(data)
        this.$refs.iotSituation.getStartData(data)
        this.$refs.healthData.getStartData(data)
        this.$refs.checkinStatistic.getStartData(data)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/dataScreen.vue